var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgStarGray(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 14,
    height: 13,
    viewBox: "0 0 14 13",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M7.27569 10.4208L10.4279 12.4179C10.8308 12.6732 11.3311 12.2935 11.2115 11.8232L10.3008 8.24052C10.2752 8.14073 10.2782 8.03573 10.3096 7.9376C10.3409 7.83946 10.3994 7.75218 10.4781 7.68577L13.3049 5.33306C13.6763 5.02392 13.4846 4.40751 13.0074 4.37654L9.31588 4.13696C9.21645 4.12986 9.12109 4.09465 9.04089 4.03545C8.96069 3.97625 8.89896 3.89548 8.86289 3.80255L7.48612 0.335486C7.44869 0.236852 7.38215 0.151935 7.29532 0.0920134C7.2085 0.0320916 7.1055 0 7 0C6.89451 0 6.79151 0.0320916 6.70468 0.0920134C6.61786 0.151935 6.55131 0.236852 6.51389 0.335486L5.13712 3.80255C5.10104 3.89548 5.03932 3.97625 4.95912 4.03545C4.87892 4.09465 4.78355 4.12986 4.68412 4.13696L0.992627 4.37654C0.515435 4.40751 0.323731 5.02392 0.695149 5.33306L3.52186 7.68577C3.60063 7.75218 3.65907 7.83946 3.69044 7.9376C3.72181 8.03573 3.72485 8.14073 3.6992 8.24052L2.85459 11.563C2.71111 12.1274 3.31143 12.583 3.79495 12.2767L6.72431 10.4208C6.8067 10.3683 6.90234 10.3405 7 10.3405C7.09767 10.3405 7.19331 10.3683 7.27569 10.4208Z",
    fill: "#ECF0F3"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgStarGray);
export default __webpack_public_path__ + "static/media/star-gray.7452de762651a9da9ccbc1ec78c22b2a.svg";
export { ForwardRef as ReactComponent };